import { createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-235336ce")

_pushScopeId("data-v-235336ce")
const _hoisted_1 = /*#__PURE__*/_createVNode("strong", null, "roberttolton", -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode(".com")
const _hoisted_3 = { class: "social-connections clearfix" }
const _hoisted_4 = { class: "nsfw-checkbox" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("span", null, [
    /*#__PURE__*/_createTextVNode("Show NSFW Content"),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createVNode("small", null, "If you decide to show NSFW (18+) content, it's at your own risk (Check over your shoulder!)")
  ])
], -1)
const _hoisted_6 = { class: "custom-checkbox" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "custom-checkbox-knob" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "custom-checkbox-layer" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("span", null, "© Robert Tolton", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_home_entry = _resolveComponent("home-entry")!
  const _component_posts_index = _resolveComponent("posts-index")!
  const _component_posts_entry = _resolveComponent("posts-entry")!
  const _component_categories_index = _resolveComponent("categories-index")!
  const _component_categories_posts_index = _resolveComponent("categories-posts-index")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("header", null, [
      _createVNode("a", {
        href: _ctx.pageData.baseUrl,
        class: "avatar"
      }, [
        _createVNode("img", {
          src: _ctx.pageData.globals.headerImage.url,
          alt: _ctx.pageData.globals.headerImage.title
        }, null, 8, ["src", "alt"])
      ], 8, ["href"]),
      _createVNode("h1", null, [
        _createVNode("a", {
          href: _ctx.pageData.baseUrl
        }, [
          _hoisted_1,
          _hoisted_2
        ], 8, ["href"])
      ]),
      _createVNode("div", _hoisted_3, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.pageData.globals.socialMediaConnections, (connection) => {
          return (_openBlock(), _createBlock("a", {
            href: connection.connectionUrl
          }, [
            _createVNode("img", {
              src: connection.connectionIconUrl,
              alt: connection.connectionName
            }, null, 8, ["src", "alt"])
          ], 8, ["href"]))
        }), 256))
      ])
    ]),
    (_ctx.pageData.section === 'home-entry')
      ? (_openBlock(), _createBlock(_component_home_entry, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.pageData.section === 'posts-index')
      ? (_openBlock(), _createBlock(_component_posts_index, { key: 1 }))
      : _createCommentVNode("", true),
    (_ctx.pageData.section === 'posts-entry')
      ? (_openBlock(), _createBlock(_component_posts_entry, { key: 2 }))
      : _createCommentVNode("", true),
    (_ctx.pageData.section === 'categories-index')
      ? (_openBlock(), _createBlock(_component_categories_index, { key: 3 }))
      : _createCommentVNode("", true),
    (_ctx.pageData.section === 'categories-posts-index')
      ? (_openBlock(), _createBlock(_component_categories_posts_index, { key: 4 }))
      : _createCommentVNode("", true),
    _createVNode("footer", null, [
      _createVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode("div", _hoisted_6, [
          _withDirectives(_createVNode("input", {
            type: "checkbox",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.appState.showNsfw = $event)),
            class: "custom-checkbox-input"
          }, null, 512), [
            [_vModelCheckbox, _ctx.appState.showNsfw]
          ]),
          _hoisted_7,
          _hoisted_8
        ])
      ]),
      _hoisted_9
    ])
  ], 64))
})